/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {CustomEventListPageComponent} from './custom-event-list-page.component';

@Component({
  standalone: true,
  imports: [CustomEventListPageComponent],
  selector: 'adn-custom-event-route-page',
  template: `
    <adn-custom-event-list-page [readOnly]="readOnly"></adn-custom-event-list-page>
  `
})
export class CustomEventRoutePageComponent {
  @Input() readOnly = false;
}
